module.exports = __webpack_public_path__ + "static/media/fastfeet.54d76094.svg";